import { render, staticRenderFns } from "./merchantList.vue?vue&type=template&id=a11cdde4&scoped=true"
import script from "./merchantList.vue?vue&type=script&lang=js"
export * from "./merchantList.vue?vue&type=script&lang=js"
import style0 from "./merchantList.vue?vue&type=style&index=0&id=a11cdde4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a11cdde4",
  null
  
)

export default component.exports